
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { reverse, forEach } from 'lodash';

import BundleItem from './BundleItem';
import Loading from '../Loding/Loading';
import { products } from '../../services';
import { NoService } from '.'

   class Bundles extends Component {
  componentDidMount() {
    const {
      setProducts,
      setMobileProducts,
      setMobileProductsForSearch,
      setFixeProducts,
      setInternetProducts,
      setTvProducts,
      setBundlesProducts,
    } = this.props;
    products.getProducts()
    .then((res) => {
      if (res) {
        if (res) {

          let mobileProducts= []
          let fixeProducts = []
          let internetProducts = []
          let tvProducts = []
          let bundlesProducts = []
          setProducts(res.body.data.userProducts);
          forEach(res.body.data.userProducts,(product) => {
            reverse(product.Options)
            if (product.Data.category === 'MOBILE') {
              mobileProducts.push(product)
            } else if (product.Data.category === 'FIXE'){
              fixeProducts.push(product)
            } else if (product.Data.category === 'INTERNET'){
              internetProducts.push(product)
            } else if (product.Data.category === 'TV'){
              tvProducts.push(product)
            } else if (product.Data.category === 'BUNDLES'){
              bundlesProducts.push(product)
            }
          })
          setMobileProducts(mobileProducts);
          setMobileProductsForSearch(mobileProducts);
          setFixeProducts(fixeProducts)
          setInternetProducts(internetProducts);
          setTvProducts(tvProducts);
          setBundlesProducts(bundlesProducts);
          this.props.loadServices();

        }
      }
    });
  }
     render() {
       const { translate, bundlesProducts, isLoaded } = this.props;
       let activeBundlesItems = [];
       let inactiveBundlesItems = []
       forEach(bundlesProducts,(product) => {
        if (product.Data.isActive ) {
          activeBundlesItems.push(
            <BundleItem
              Data={product.Data}
              userProducts={product.Data.userProducts}
              isFrozen={product.Data.isFrozen}
              hasFutureFreeze={product.Data.hasFutureFreeze}
              isActive={product.Data.isActive}
              userProductId={product.Data.userProductId}
              offer={product.Data.offer}
              title={product.Data.offer}
              subscription1={translate('installation-address')}
              subtitle1={product.Data.dataAddress}
              createdDate={product.Data.createdDate}
              simNumber={product.Data.simNumber}
              provider={product.Data.provider}
              options={product.Options}
              key={product.Data.userProductId}
              hasFutureMispari={product.Data.hasFutureMispari}
              hasMispariActive={product.Data.hasMispariActive}

            />
          )
        } else if (!product.Data.isActive) {
          inactiveBundlesItems.push(
            <BundleItem
               Data={product.Data}
               userProducts={product.Data.userProducts}
               isFrozen={product.Data.isFrozen}
               hasFutureFreeze={product.Data.hasFutureFreeze}
               isActive={product.Data.isActive}
               userProductId={product.Data.userProductId}
               offer={product.Data.offer}
               title={product.Data.offer}
               subscription1={translate('installation-address')}
               subtitle1={product.Data.dataAddress}
               createdDate={product.Data.createdDate}
               simNumber={product.Data.simNumber}
               provider={product.Data.provider}
               options={product.Options}
               key={product.Data.userProductId}
               hasFutureMispari={product.Data.hasFutureMispari}
               hasMispariActive={product.Data.hasMispariActive}

             />
            )
          }
        })
       const inactiveItemsBundles = inactiveBundlesItems[0] ?
       <div>
         <h3 className="service-section-title">
           <span>{translate('inactives')}</span>
           <i className="material-icons ng-binding collapsed" data-toggle="collapse" data-target="#inactive" aria-expanded="false" >
             keyboard_arrow_down
           </i>
         </h3>
         <div id="inactive" className="collapse">
           { inactiveBundlesItems }
         </div>
       </div>
        : '';
     return (
       <div className="service">
         <h1 className="title">{translate('bundles')}</h1>
          <div className="form-group">
            <input className="form-control" type="text" placeholder={this.props.translate('search-line')} onChange={this.handleChange} />
           </div>
         { isLoaded ? activeBundlesItems[0] ? activeBundlesItems : NoService(translate) : Loading() }
         { inactiveItemsBundles }
       </div>
       );
     }
}


const viewMapStateToProps = (state) => {
  return {
    products: state.Products.products,
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    bundlesProducts: state.Products.bundlesProducts,
    isLoaded: state.User.isLoaded,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setProducts: (products) => {
      dispatch(
        {
          type: 'SET_PRODUCTS',
          products: products,
        },
      );
    },
    setMobileProducts: (products) => {
      dispatch(
        {
          type: 'SET_MOBILE_PRODUCTS',
          products: products,
        },
      );
    },
    setMobileProductsForSearch: (products) => {
      dispatch(
        {
          type: 'SET_MOBILE_PRODUCTS_FOR_SEARCH',
          products: products,
        },
      );
    },
    setFixeProducts: (products) => {
      dispatch(
        {
          type: 'SET_FIXE_PRODUCTS',
          products: products,
        },
      );
    },
    setInternetProducts: (products) => {
      dispatch(
        {
          type: 'SET_INTERNET_PRODUCTS',
          products: products,
        },
      );
    },
    setBundlesProducts: (products) => {
      dispatch(
        {
          type: 'SET_BUNDLES_PRODUCTS',
          products: products,
        },
      );
    },
    setTvProducts: (products) => {
      dispatch(
        {
          type: 'SET_TV_PRODUCTS',
          products: products,
        },
      );
    },
    loadServices: () => {
      dispatch({
        type: 'LOAD_SERVICES_INFO',
        isLoaded: true,
      });
    },
  }
}

Bundles = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(Bundles);

export default Bundles;



// WEBPACK FOOTER //
// ./src/components/MyServices/Bundles.js